
export const callOutStyles = {
  calloutMain: {
    padding: '24px 16px',
    overflow: 'inherit', // not hide date picker
  },
};
